module.exports = __webpack_public_path__ + "img/1_D.3ca76a73.webp";